import { Analytics } from '@simple-life-app/simple-growth-frontend-tools'

export default {
	install: (Vue, { options, router, store }) => {
		const analytic = new Analytics(options)

		// Проверяем превью мод один раз при инициализации
		const isPreviewMode = store.getters.isPreviewMode

		// Регистрируем router hook только если не превью мод
		if (!isPreviewMode) {
			router.beforeEach((to, from, next) => {
				const hasAnalyticData = Boolean(to.meta.pageAnalyticUxEvent)

				if (hasAnalyticData && !Boolean(to.query.popup)) {
					const { name, data } = to.meta.pageAnalyticUxEvent

					analytic.logEvent(name, data)
				}

				next()
			})
		}

		// Создаем методы аналитики с учетом превью мода
		const createAnalyticMethod = (originalMethod) => {
			return isPreviewMode ? () => Promise.resolve() : originalMethod
		}

		Vue.prototype.$analytic = {
			logEvent: createAnalyticMethod((eventName, eventProperties) => {
				const { funnel } = store.getters['location/getAppAreaConfig']
				const initialFunnelType = store.getters['location/getInitialFunnelType']

				return analytic.logEvent(eventName, {
					url: window.location.href,
					initial_funnel_type: initialFunnelType,
					funnel_type: funnel.slug,
					funnel_id: funnel.id,
					...eventProperties,
				})
			}),
			setUserProperties: createAnalyticMethod((...args) => {
				// Note: этот метод можно будет перенести в Jet после отказа от Amplitude
				store.dispatch('survey/handleUserAnalyticData', ...args)
				return analytic.setUserProperties(...args)
			}),
			initDestinationPlugins: (...args) => analytic.initDestinationPlugins(...args),
			setUserId: (...args) => analytic.setUserId(...args),
		}
	},
}
